import SoftBox from "components/SoftComponents/SoftBox";
import SoftButton from "components/SoftComponents/SoftButton";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import { Card } from "@mui/material";


function MapLinkButton({ locations, backgroundColor = "#f5f5f5", dimensions = "32px" }) {

    const user_location = locations.user_loc;
    const destination_location = locations.dest_loc;

    try {
        if (user_location[0] == 0 && user_location[1] == 0) {
            var mapUrl = `https://www.google.com/maps/dir//${destination_location[1]},${destination_location[0]}`;
        }
        else {
            var mapUrl = `https://www.google.com/maps/dir/${user_location[0]},${user_location[1]}/${destination_location[1]},${destination_location[0]}`;
        }
    }
    catch (e) {
        console.error(e);
        var mapUrl = `https://www.google.com/maps/dir//${destination_location[1]},${destination_location[0]}`;
    }

    return (
        <Card sx={{ backgroundColor }}>
            <SoftBox component={Link} to={mapUrl} target="_blank" rel="noreferrer" display="flex" justifyContent="center" alignItems="center" sx={{ height: `${dimensions} !important`, width: `${dimensions} !important` }}>
                <SoftBox display="flex" justifyContent="center" alignItems="center" sx={{ borderRadius: "100%", backgroundColor: '#fff', maxHeight: '20px !important', maxWidth: '20px !important' }} >
                    <AssistantDirectionIcon fontSize="medium" />
                </SoftBox>
            </SoftBox>
        </Card>
    );
};

MapLinkButton.propTypes = {
    locations: PropTypes.object,
    backgroundColor: PropTypes.string,
    dimensions: PropTypes.string,
}

export default MapLinkButton;